import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { Link } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import Modal2 from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import { VictoryBar,VictoryLine,VictoryChart,VictoryTheme,VictoryLabel,VictoryAxis,VictoryScatter,VictoryLegend } from 'victory';
import TopBar from '../components/TopBar';
import XLSX from 'xlsx';
import { NotificationManager} from 'react-notifications';
var FileSaver = require('file-saver');
 function s2ab(s) {
var buf = new ArrayBuffer(s.length);
var view = new Uint8Array(buf);
for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
return buf;
}
const days = [0, 1, 2, 3, 4, 5];

let _this;
const DWIDTH = 980;

class Practice extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0, message: '', CLASSES:[],showResultDetail:false,showChart:false,curLegend:'All',result:{},dayOnline:7};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });


  }

  async loadBingo(){
    let sDoc = await firebase.firestore().collection('Marathon').doc("#Setting").get();
    //console.log(sDoc.exists)
    if(sDoc.exists)
    {
      let setting = sDoc.data();
      setting.id = sDoc.id;
      if(moment(setting.endTime).isBefore(moment())||moment(setting.startTime).isAfter(moment()))
      {

        //return;
      }
      _this.setState({setting});

    }
  }

  async loadClasses() {
    let ACCOUNT = store.getState().ACCOUNT;
    console.log(ACCOUNT.idchinhanh);
    let data = await firebase.firestore().collection('data_classes').where('idchinhanh','==',ACCOUNT.idchinhanh).where('enable','==',1).get();
    if (data.size>0) {
      let CLASSES=[];
      data.forEach((doc)=>{
          let item = doc.data();

          if(item.enable==1)
        CLASSES.push(item);
      })
        _this.setState({ CLASSES });


    }

  }

  componentDidMount() {

    this.loadBingo();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    // let LASTDAY = localStorage.getItem('LASTDAY');
    // if (LASTDAY) {
    //   LASTDAY = JSON.parse(LASTDAY);
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    // }
    // else {
    //   LASTDAY = { week: 0, day: 1 };
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    //   localStorage.setItem('LASTDAY', JSON.stringify(LASTDAY));
    // }

  this.setState({  loading: false });
    this.loadClasses();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }




  backClick() {
    if(_this.state.curClass)
    {
      _this.setState({ curClass:false,STUDENTS:[] });
    }


    else {
      this.props.history.push('/');
    }
  }
async loadSTUDENTS(curClass){
  console.log(curClass.id);
  let data = await firebase.firestore().collection('data_students').where('idlop','==',curClass.id).where('enable','==',1).get();
  if (data.size>0) {
    let STUDENTS=[];
    data.forEach((doc)=>{
        let item = doc.data();
        //console.log(moment(item.todate).diff(moment(),"days"));
        if(item.enable==1&&moment(item.todate).diff(moment(),"days")>-30)
        //console.log(item.todate);
      STUDENTS.push(item);
    })


      _this.setState({ STUDENTS });
  }
}
  async selectClass(curClass){
    _this.setState({curClass,STUDENTS:[]});
    _this.loadSTUDENTS(curClass);
  }
  getCourseNameForId(id){
    let DATA_COURSES = store.getState().DATA_COURSES;
    let course = _.find(DATA_COURSES,{id:id})

    if(course)
    {
      return course.ten
    }
    return '';
  }
  getCourseForId(id){
    let DATA_COURSES = store.getState().DATA_COURSES;
    let course = _.find(DATA_COURSES,{id:id})

    if(course)
    {
      return course
    }
    return false;
  }
  async showChartResult(id_course,id_student,name_student){
    console.log(id_course,id_student,name_student);
    await _this.setState({loading:true});
    let data = await firebase.firestore().collection('courses').where('course_id','==',id_course).get();
    console.log(id_course);
    let course = {};
    if (data.size>0) {
      data.forEach(doc=>{
        course = doc.data();
      })
    }
    if(!course||!course.id){
        // alert(_this.props.t('class.no_result'));
        // return;
        course={id:"0",week:12};
    }

     let doc  = await firebase.firestore().collection('data_students').doc("data_students"+'-'+id_student).collection("results").doc(course.id).get();
    let RESULTS = [];
    let chartData = [];
    let aData = await firebase.firestore().collection('data_students').doc("data_students"+'-'+id_student).collection(course.id).orderBy("created", "desc").get();
    if(aData.size>0)
    {
      aData.forEach(doc=>{
        let r = doc.data();
        RESULTS.push(r);
      })
    }
    if(doc.exists)
    {
      let rArr = doc.data().results;
      rArr.forEach(item=>{
        RESULTS.push(item);
      });
    }
    for(let i=0;i<course.week;i++)
    {
      let filtered = RESULTS.filter(t=>t.week==i);

      let percent = _.sumBy(filtered, 'percent');
      //console.log(filtered,percent);
      percent = percent?Math.round(percent/filtered.length):0;
      let item = {name:(i+1).toString(),percent,length:filtered.length};
      chartData.push(item);
    }
    //console.log(chartData);
    let doc2 = await firebase.firestore().collection('data_students').doc("data_students"+'-'+id_student).collection("results").doc('_ADVANCE_').get();
    let RESULTS2 = [];
    let chartData2 = [];
    let dateList = [];
    for(let i=29;i>=0;i--)
    {
      let item =  moment().subtract(i, "days").format("YYYY-MM-DD");
      dateList.push(item);
    }
      let legends = [];
      let keyOptions = ['All'];
      let startDate = moment().subtract(29, "days").format("YYYY-MM-DD")+" 00:00:00";
      let aData2 = await firebase.firestore().collection('data_students').doc("data_students"+'-'+id_student).collection("_ADVANCE_").where("created",">=",moment(startDate).valueOf()).orderBy("created", "desc").get();
      let rArr = [];
      if(aData2.size>0)
      {
        aData2.forEach(doc=>{
          let r = doc.data();
          rArr.push(r);
        })
      }
      if(doc2.exists)
      {
         rArr = rArr.concat(doc2.data().results);
       }
       if(rArr.length>0) {

      rArr.forEach(item=>{
        item.date=moment(item.created).format('YYYY-MM-DD');
        if(item.date>=dateList[0]&&item.group!=undefined)
        {
          if(item.group&&item.group!="")
          {
            RESULTS2.push(item);
          }
        }
      });
      RESULTS2 = _.sortBy(RESULTS2,['date'],['desc']);
      RESULTS2 = _.groupBy(RESULTS2,'group');


      for (let key of Object.keys(RESULTS2))
      {
        let agroup = STATIC.AGROUP[key];

        legends.push({name:key,symbol:{fill:agroup.color,type:agroup.symbol}})
        keyOptions.push(key);
        let tArr= [];
        for(let rel of dateList)
        {
          //console.log(rel);
          let arr = RESULTS2[key].filter(i=>i.date==rel);
          let percent = 0;
          if(arr.length>0)
          {
             percent = _.sumBy(arr, 'percent');
            percent = percent?Math.round(percent/arr.length):0;
          }

        //  console.log(arr);

          let item = {name:moment(rel,'YYYY-MM-DD').format('DD-MM').toString(),y:percent,...STATIC.AGROUP[key],key,date:rel};
          tArr.push(item);
        }

        chartData2.push(tArr);
      }

    }
    //if((RESULTS&&RESULTS.length>0)||(RESULTS2&&RESULTS2.length>0))
    _this.setState({showChart:true,chartData,RESULTS,RESULTS2,chartData2,legends,name_student,keyOptions,curLegend:'All',showAdvanceResult:false,loading:false});
    //else {
    //  alert(_this.props.t('class.no_result'));
    //}
  }
  async showChartDetailResult(index){
    let {RESULTS} = _this.state;
    let chartDetailData = [];
    for(let i=0;i<6;i++)
    {
      let filtered = RESULTS.filter(t=>t.week==index&&t.day==i);
      let percent = _.sumBy(filtered, 'percent');
  //console.log(filtered,percent);
      percent = percent?Math.round(percent/filtered.length):0;
      let item = {name:(i+1).toString(),percent,length:filtered.length};
      console.log(item);
      chartDetailData.push(item);
    }
    _this.setState({showChartDetail:true,chartDetailData,chartWeekIndex:index});
  }

  clickChart(index)
  {
    if(_this.state.showChartDetail)
    {
      let {chartWeekIndex,RESULTS} = _this.state;
      let filtered = RESULTS.filter(t=>t.week==chartWeekIndex&&t.day==index);
      if(filtered&&filtered.length>0)
      _this.setState({showResultDetail:true,fResults:filtered,result:filtered[0],rIndex:0});
      return;
    }
    _this.showChartDetailResult(index);
  }
  clickChart2(key,date)
  {

      let {RESULTS2} = _this.state;
      let filtered = RESULTS2[key].filter(i=>i.date==date);
      if(filtered&&filtered.length>0)
      _this.setState({showResultDetail:true,fResults:filtered,result:filtered[0],rIndex:0});


  }
  changeResult(index)
  {
    let {fResults} = _this.state;
    if(index<=fResults.length-1&&index>=0)
    {
      _this.setState({result:fResults[index],rIndex:index});
    }
  }
  getQuestionEQ(question,width)
  {
    let rel = '';
    if(question.type!="image"&&question.type!="soroban")
    {

      for(let num of question.numbers)
      {
        if(question.type!='multiple'&&question.type!='divide')
        {
          if(rel=='')
          {
            rel=num;
            continue;
          }
          else {
            rel += (num>=0?' + ':' - ')+Math.abs(num);
          }
        }
        else {
          if(rel=='')
          {
            rel+=num;
          }
          else {
            rel+=""+num;
          }
        }

      }
    }
    else
    if(question.type=="soroban")
    {
      rel = "Soroban";
    }
    else {
      rel = (<div style={{display:'inline-block'}}>{question.images.map((i,index)=>{
        return (<img key={"image"+index}
    src={i}
    style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />)
      })}

      </div>)
    }
    return rel;
  }
  async exchangePoint(student)
  {
    if(!student.point||student.point<=0)
    {
        alert(_this.props.t('class.no_point'));
      return;
    }
    if(!window.confirm(_this.props.t('class.want_to_exchange',{point:student.point})))
    {
      return;
    }
    let ACCOUNT = store.getState().ACCOUNT;
    let res = await STATIC.postFormData(STATIC.API_STUDENT_EXCHANGEPOINT,{id_student:student.id,id_teacher:ACCOUNT.id});
    if(res && res.status==1)
    {
      alert(_this.props.t('class.exchanged',{point:res.point}));
      student.point = 0;
      _this.forceUpdate();
    }
    else {
      alert(_this.props.t('class.not_success'));
    }

  }
  handleChangeDigits = (name,max) => event => {

    let value = event.target.value;
    if(value>max)
    {
      value=max;
    }

    this.setState({
      [name]: value
    });

  }
  async saveMSetting()
  {
    _this.setState({showSetRow:false})
    let MSetting = _this.state.student.MSetting||{name:"",showTime:0,qCount:0};
    let ACCOUNT = _this.state.student;
    if(!_this.state.student.MSetting||_this.state.student.MSetting.name=="")
    {
      let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
      if (data.size>0) {
        let item = {};
        data.forEach((doc)=>{
          item = doc.data();
          item.id = doc.id;
        })
        if (item.weeks&&item.MarathonSetting)
        {
          // let doc =  await firebase.firestore().collection("data_students").doc("data_students"+'-'+ACCOUNT.id).collection('lastdays').doc(item.id).get();
          //
          // let LASTDAY = {week:0,day:1}
          // if(doc.exists)
          // {
          //   LASTDAY = doc.data();
          // }
          let fromdate = item.startDate;
          let todate = item.endDate;
          let sACC = ACCOUNT;
          if(sACC)
          {
            lastday = STATIC.getBusinessDays(moment(),moment(sACC.fromdate));
            fromdate = sACC.fromdate;
            todate = sACC.todate;
          }

          fromdate = moment(fromdate);
          todate = fromdate.clone().add(item.week*7,"days");;

          //let todate = fromdate.add(item.week*7,"days");


        //  console.log(1,todate.format("L"),fromdate.format("L"));

          let hData =  await firebase.firestore().collection("data_holiday").where('idchinhanh','==',ACCOUNT.idchinhanh).orderBy("fromdate").get();
          let items = [];
          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              items.push(hItem);
            })

            let checkDate = STATIC.checkTodate(items,fromdate,todate,item.week);
            todate = checkDate.todate;
            fromdate = checkDate.fromdate;
          }
          if(moment().isSameOrBefore(todate))
          {
            todate = moment();
          }
          //console.log(2,todate.format("L"),fromdate.format("L"));
          let lastday = STATIC.getBusinessDays(todate,fromdate);
          //console.log(lastday);
          let holiday = 0;



          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')||moment(hItem.todate).isBetween(fromdate,todate,'day','[]')||(fromdate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]')&&todate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]'))){

                let tHoliday = 0;
                if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')&&moment(hItem.todate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),moment(hItem.fromdate));

                }
                else if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(todate,moment(hItem.fromdate));

                }
                else if(moment(hItem.todate).isBetween(fromdate,todate,'day','[]')) {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),fromdate);
                }
                else {
                  tHoliday = lastday;
                }
                //console.log(tHoliday);
                holiday+=tHoliday;
              }
            })
          }
        //  console.log(lastday,holiday);
          //console.log(sACC.fromdate,lastday);
          lastday = lastday - holiday;
        //  console.log(lastday);
          if(lastday<0)
          lastday = 0;
        //  console.log(lastday,moment().format(),moment(sACC.fromdate,'MM/DD/YYYY hh:mm:ss A').format());
          let cWeek = Math.ceil((lastday+1)/6)-1;
          let cDay = lastday%6;
          //cWeek = 12;
          //console.log(cWeek,item.week-1);
          if(cWeek>item.week-1){
            cWeek = item.week-1;
            cDay = 5;
          }
          item.cWeek = cWeek;
          item.cDay = cDay;
          //console.log(cWeek,cDay)

          let selectedDay = item.weeks["w" + cWeek]["d" + (cDay)];
          //let selectedDay = item.weeks["w" + LASTDAY.week]["d" + (LASTDAY.day-1)];
          let type = selectedDay.type[0];
          let mName =  "Flashcard";
          let sMSetting = ACCOUNT.MSetting||{};

        //  console.log(type);
          if(type=="image"||type=="soroban")
          {
            type = [type];
            mName = "Flashcard";
          }
          else
          if(type=="LB_0")
          {
            type = [type];
            mName= "Basic";
          }else
          if(type=="LB_1"||type=="LB_2"||type=="LB_3"||type=="LB_4"||type=="LB_-1"||type=="LB_-2"||type=="LB_-3"||type=="LB_-4")
          {
            type = ["LB_1","LB_2","LB_3","LB_4"];
            mName= "LB+";
          }else
          if(type=="LB_-1"||type=="LB_-2"||type=="LB_-3"||type=="LB_-4")
          {
            type = ["LB_-1","LB_-2","LB_-3","LB_-4"];
            mName= "LB-";
          }else
          if(type=="BB_1.1"||type=="BB_2.1"||type=="BB_3.1"||type=="BB_4.1"||type=="BB_5.1"||type=="BB_6.1"||type=="L&B_6.2"||type=="BB_7.1"||type=="L&B_7.2"||type=="BB_8.1"||type=="L&B_8.2"||type=="BB_9.1"||type=="L&B_9.2")
          {
            type = ["BB_1.1","BB_2.1","BB_3.1","BB_4.1","BB_5.1","BB_6.1","BB_7.1","BB_8.1","BB_9.1","L&B_6.2","L&B_7.2","L&B_8.2","L&B_9.2"];
            mName= "BB+";
          }else
          if(type=="BB_-1.1"||type=="BB_-2.1"||type=="BB_-3.1"||type=="BB_-4.1"||type=="BB_-5.1"||type=="BB_-6.1"||type=="L&B_-6.2"||type=="BB_-7.1"||type=="L&B_-7.2"||type=="BB_-8.1"||type=="L&B_-8.2"||type=="BB_-9.1"||type=="L&B_-9.2")
          {
            type = ["BB_-1.1","BB_-2.1","BB_-3.1","BB_-4.1","BB_-5.1","BB_-6.1","BB_-7.1","BB_-8.1","BB_-9.1","L&B_-6.2","L&B_-7.2","L&B_-8.2","L&B_-9.2"];
            mName= "BB-";
          }
          else {
            type = ["LB_1","LB_2","LB_3","LB_4","LB_-1","LB_-2","LB_-3","LB_-4","BB_1.1","BB_2.1","BB_3.1","BB_4.1","BB_5.1","BB_6.1","BB_7.1","BB_8.1","BB_9.1","L&B_6.2","L&B_7.2","L&B_8.2","L&B_9.2","BB_-1.1","BB_-2.1","BB_-3.1","BB_-4.1","BB_-5.1","BB_-6.1","BB_-7.1","BB_-8.1","BB_-9.1","L&B_-6.2","L&B_-7.2","L&B_-8.2","L&B_-9.2"];
            mName= "+/-";
          }

          let find = item.MarathonSetting.find(f=>f.name==mName);
          if(find)
          {
            let rows = _this.state.rows;
            MSetting = {type,rows,...find};
            if(sMSetting.name==MSetting.name)
            {
              MSetting={...MSetting,rows:sMSetting.rows};
            }
            // else {
            //   if(mName!="Flashcard")
            //   _this.setState({showSetRow:true});
            // }
          }
      }
    }
  }

    MSetting.rows = parseInt(_this.state.rows);
    let student = _this.state.student;
    student.MSetting = MSetting;

    await STATIC.postFormData(STATIC.API_STUDENT_MARATHON,{id:_this.state.student.id,MSetting:JSON.stringify(MSetting)});
    _this.setState({student})

  }
  async exportOnline(student)
  {
    if(!student.MarathonBegin||!student.MarathonLast)
    {
      return;
    }

    await this.setState({loading:true})
    let startDate = parseInt(moment(student.MarathonBegin).format("YYYYMMDD"));
    let endDate = parseInt(moment(student.MarathonLast).format("YYYYMMDD"));
    let data = await firebase.firestore().collection('MarathonOnline').where("id_student","==",student.id).where("day",">=",startDate).where("day","<=",endDate).orderBy("day").get();
    let sArr = [];
    if(data.size>0)
    {

      data.forEach(doc=>{
        sArr.push(doc.data())
      })

      // for(let i of sArr)
      // {
      //   let macn = i.idchinhanh;
      //   let tArr = i.mahs.split("-");
      //   if(tArr.length>0)
      //   macn = tArr[0];
      //   csvData.push([index,macn,i.mahs,i.ten,i.MarathonTDay,i.MarathonOffDay,i.MarathonCDay,moment(i.MarathonLast).format("DD/MM/YYYY")])
      // }
      // // console.log(csvData);
      // // _this.setState({csvData,downloadCSV:true});
      // var wb = XLSX.utils.book_new();
      // let filename = "Marathon - "+item.day;
      // wb.SheetNames.push(filename);
      // var ws = XLSX.utils.aoa_to_sheet(csvData);
      // wb.Sheets[filename] = ws;
      // var contents = XLSX.write(wb, {bookType: 'xlsx',bookSST: true, cellStyles: true, type: 'binary'});
      // var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
      // FileSaver.saveAs(blob, filename+"_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
    }
    let headers = ["Ngay","So lan lam bai","Tinh Trang"];
    let csvData = [headers];

    let totalDays = moment(student.MarathonLast).diff(moment(student.MarathonBegin),"days")+1;
    console.log(totalDays);
    for(let i=0;i<totalDays;i++)
    {
      let cDay = moment(student.MarathonBegin).add(i,"days").format("YYYYMMDD");
      let find = sArr.find(s=>s.day==parseInt(cDay));
      if(find)
      {
        csvData.push([cDay,find.count,"Online"])
      }
      else {
        csvData.push([cDay,0,"Offline"])
      }
    }
    var wb = XLSX.utils.book_new();
    let filename = "BB - "+student.mahs;
    wb.SheetNames.push(filename);
    var ws = XLSX.utils.aoa_to_sheet(csvData);
    wb.Sheets[filename] = ws;
    var contents = XLSX.write(wb, {bookType: 'xlsx',bookSST: true, cellStyles: true, type: 'binary'});
    var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
    FileSaver.saveAs(blob, filename+"_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
    await this.setState({loading:false})
    //console.log(data.size);
  }
  exportByDay = async ()=>{
    //await this.setState({loading:true})
    // if(this.state.dayOnline>0)
    // {
      await this.setState({loading:true})
      let ACCOUNT = store.getState().ACCOUNT;
      let doc = await firebase.firestore().collection('Marathon').doc("#Setting").get();

      if(doc.exists)
      {
        let setting = doc.data();
        setting.id = doc.id;
        let data = await firebase.firestore().collection('data_students').where('idchinhanh','==',ACCOUNT.idchinhanh).where("MarathonTDay",">",parseInt(0)).get();
        if(data.size>0)
        {
          let sArr = [];
          data.forEach(doc=>{
            sArr.push(doc.data())
          })
          sArr = _.sortBy(sArr,['mahs'],['asc']);
          let headers = ["STT","Mã Chi Nhánh","Mã HV","Họ và Tên","Số ngày online liên tục","Số ngày nghỉ","Ngày online hiện tại","Ngày online lần cuối","Quà Tặng"];
          let csvData = [headers];
          let index = 1;
          for(let i of sArr)
          {
            //let dRewards = [];
            let dRewardsName = [];
            for(let j=0;j<setting.rewards.length;j++)
            {
              let t= _.cloneDeep(setting.rewards[j]);
              if(i.MarathonTDay>=t.day)
              dRewardsName.push(t.name);
            }
            let reward = dRewardsName.join(",");
            let macn = i.idchinhanh;
            let tArr = i.mahs.split("-");
            if(tArr.length>0)
            macn = tArr[0];
            csvData.push([index,macn,i.mahs,i.ten,i.MarathonTDay,i.MarathonOffDay,i.MarathonCDay,moment(i.MarathonLast).format("DD/MM/YYYY"),reward])
          }
          // console.log(csvData);
          // _this.setState({csvData,downloadCSV:true});
          var wb = XLSX.utils.book_new();
          let filename = "Marathon - "+ACCOUNT.idchinhanh;
          wb.SheetNames.push(filename);
          var ws = XLSX.utils.aoa_to_sheet(csvData);
          wb.Sheets[filename] = ws;
          var contents = XLSX.write(wb, {bookType: 'xlsx',bookSST: true, cellStyles: true, type: 'binary'});
          var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
          FileSaver.saveAs(blob, filename+"_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
        }
        else {
          NotificationManager.error("Not Found!");
        }
      }

      await this.setState({loading:false})

  //  }
    // else
    // NotificationManager.error("Day must be greater than 0!");
  }

  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight, CLASSES,STUDENTS,curClass,showChart,legends,name_student,showResultDetail,result,setting } = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1010;

    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;



    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT||ACCOUNT.type==0) {

      return (<Redirect to='/' />);
    }
    let chartData2 = this.state.chartData2;
    if(this.state.curLegend!=''&&this.state.curLegend!='All')
    {
      let index = this.state.keyOptions.indexOf(this.state.curLegend);
      console.log(index);
      if(index>-1 && chartData2.length>index-1)
      {
        chartData2 = [chartData2[index-1]];
      }
    }
    let bWidth = width-STATIC.calSize(40, STATIC.DWIDTH, width);
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{curClass?curClass.ten:t('common.classes')}</div>
                </div>

                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

              </div>
              <div style={{display:"flex",flexDirection:"rows"}}>
                <Button onClick={()=>this.exportByDay()}  style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmall}}>
                  {t('common.export')} {t('common.list')}
                </div>
              </Button>
              <Button onClick={()=>this.props.history.push("/marathon_ranking")}  style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
              <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmall}}>
                {t('common.ranking')}
              </div>
            </Button>
            <Button onClick={()=>this.props.history.push("/chartviewTeacher?id="+ACCOUNT.id)}  style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
              <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmall}}>
                {t('common.advance')}
              </div>
            </Button>
              </div>

              <div style={{position:'relative',overflow:'auto',height:STATIC.calSize(600, STATIC.DWIDTH, width)}}>
                {curClass?
                  STUDENTS.map((s,index)=>{
                    let course = _this.getCourseForId(s.idkhoahoc);
                  return (<div
                    key={"s"+index}
                    style={{ width: bWidth, minHeight: bWidth*0.15,marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), backgroundColor: '#8bc53f', display: 'flex',flexDirection:'row' }}>
                      <div style={{borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width),minWidth:bWidth*0.15,display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'rgba(0,0,0,0.5)'}}>
                          <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',textTransform:'uppercase' }} >{index+1}</div>
                      </div>
                  <div style={{flexGrow:1,paddingLeft:STATIC.calSize(10, STATIC.DWIDTH, width),position:'relative'}}>
                    <div style={{ color: 'rgb(5, 63, 34)', fontSize: fNormal,textAlign:'left',textTransform:'uppercase',width:'100%' }} >{s.ten}</div>
                    <div style={{display:'flex',flexDirection:'row'}}>
                      <div style={{ color: '#fffdde', fontSize: fSmall,textAlign:'left' }} >{t('common.course')}: {course.ten}</div>
                      <div style={{ color: '#fffdde', fontSize: fSmall,textAlign:'left',textTransform:'uppercase',marginLeft:'auto',marginRight:STATIC.calSize(20, STATIC.DWIDTH, width) }} >{s.point?s.point:0} {t('common.power')}</div>
                    </div>
                    <div style={{ color: '#fffdde', fontSize: fSmall,textAlign:'left',width:'100%',display:'flex',alignItems:"center",flexDirection:'row' }} ><div>Online: {s.MarathonTDay||0} {t('common.day')} - Off: {s.MarathonOffDay||0} {t('common.day')}</div>
                    <div style={{flexGrow:1}}></div>
                      {s.MarathonBegin&&<Button onClick={()=>this.exportOnline(s)}  style={{marginRight:STATIC.calSize(20, STATIC.DWIDTH, width),  color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                    <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontSize: fSmall}}>
                      {t('common.detail')}
                    </div>
                  </Button>}
                      </div>
                    <div style={{ color: '#fffdde', fontSize: fSmall,display:'flex',flexDirection:'row',alignItems:"center",textAlign:'left',textTransform:'uppercase',width:'100%' }} ><div>{setting.name&&setting.name.length>0?setting.name:""}: {s.MarathonCDay||0} {t('common.day')}</div>
                    <div style={{flexGrow:1}}></div>
                    {s.MSetting?<Button onClick={()=>this.setState({student:s,rows:s.MSetting.rows,showSetRow:true})}  style={{marginRight:STATIC.calSize(20, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                      {s.MSetting.name!=""?<div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontSize: fSmall}}>
                        {s.MSetting.name}/{s.MSetting.rows}R/{s.MSetting.showTime}S/{s.MSetting.qCount}Q
                      </div>:<div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontSize: fSmall}}>
                        {s.MSetting.rows}R
                      </div>}
                    </Button>:<Button onClick={()=>this.setState({student:s,rows:3,showSetRow:true})}  style={{marginRight:STATIC.calSize(20, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'inline-block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                    <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontSize: fSmall}}>
                      {t('common.set_rows')}
                    </div>
                  </Button>}</div>
                    <Divider style={{width:'100%',alignSelf:'center', marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "white", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width)}}>
                      <Button style={{ color: "#053f22", padding: (STATIC.calSize(3, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(8, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained" onClick={()=>this.showChartResult(course.id,s.id,s.ten)} >
                        {t('common.results')}
                      </Button>
                      <Button style={{ color: "#053f22",marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width), padding: (STATIC.calSize(3, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(8, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained" onClick={()=>this.exchangePoint(s)} >
                        {t('common.ex_point')}
                      </Button>
                    </div>
                  </div>



                </div>)
                })
                  :
                  CLASSES.map((c,index)=>{
                  return (<ButtonBase
                    onClick={()=>this.selectClass(c)}
                    key={index}
                    focusRipple
                    style={{ width: bWidth, minHeight: bWidth*0.15,padding:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), backgroundColor: '#8bc53f', display: 'flex',flexDirection:'column',justifyContent:'center',alignItems:'flex-start', cursor: 'pointer' }}>
                  <div style={{ color: 'rgb(5, 63, 34)', fontSize: fTitle,textAlign:'center',textTransform:'uppercase',width:bWidth-STATIC.calSize(20, STATIC.DWIDTH, width) }} >{c.ten}</div>
                  <Divider style={{width:bWidth*0.5,alignSelf:'center', marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "white", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
                  <div style={{ color: '#fffdde', fontSize: fNormal,textAlign:'center',width:bWidth-STATIC.calSize(20, STATIC.DWIDTH, width) }} >{t('common.begin')}: {moment(c.ngaybatdau).format('DD/MM/YYYY')} - {t('common.end')}: {moment(c.ngayketthuc).format('DD/MM/YYYY')}</div>

                <div style={{ color: 'white', fontSize: fNormal }} ></div>
                  </ButtonBase>)
                })}

              </div>
              <Link to="/" style={{ width: '100%' }}>
                <img
                  src="assets/web/logo_green.png"
                  style={{ maxWidth: 296, height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>

            </div>


          </div>


        </div>
        <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>this.setState({showBBExport:false})} showCloseIcon={false} focusTrapped={false} open={this.state.showBBExport} center>
          <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
            <div style={{ display: 'flex',flexDirection:'column',justifyContent:'center',alignItems:'center' }}>

                <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.day')} Online</div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('dayOnline',999)}
                      value={this.state.dayOnline}
                      type="number"
                      min={7}
                      max={999}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>


                  <Button onClick={()=>{this.setState({showBBExport:false},()=>this.exportByDay())}} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                    {t('common.export')}
                  </Button>

                </div>
                </div>
              </div>
            </Modal>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'white',textAlign:'center' } }} open={showResultDetail} onClose={() => this.setState({ showResultDetail: false })} center>
          <div>
              {result.created?<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
              {_this.state.rIndex>0?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginRight:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex-1)}>
                  {"<"}
                </Button>:false}
              <div style={{fontSize: fSmall}}>{moment(result.created).format("DD/MM/YYYY HH:mm")}</div>
            {_this.state.rIndex<_this.state.fResults.length-1?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex+1)}>
                {">"}
              </Button>:false}</div>:false}
                <Grid container direction="row" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}} >
                    <Grid item xs={1} >
                      <div style={{fontSize: fSmall}}>{t('common.id')}</div>
                    </Grid>
                    <Grid item xs={5} >
                      <div style={{fontSize: fSmall,textAlign:'left'}}>{t('common.question')}</div>

                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.input')}</div>
                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.correct')}</div>

                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.result')}</div>
                    </Grid>
                </Grid>
                <Divider />
                {result&&result.questions?result.questions.map((q,index)=>{
                  return (<Grid key={index} container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}} >
                      <Grid item xs={1} >
                        <div style={{fontSize: fSmall}}>{index+1}</div>
                      </Grid>
                      <Grid item xs={5} >
                        <div style={{fontSize: fSmall,textAlign:'left'}}>{this.getQuestionEQ(q,width)} =</div>

                      </Grid>
                      <Grid item xs={2} >
                        <div style={{fontSize: fSmall}}>{q.answer}</div>

                      </Grid>
                      <Grid item xs={2} >
                        <div style={{fontSize: fSmall}}>{q.result}</div>

                      </Grid>
                      <Grid item xs={2} >
                        <div style={{fontSize: fNormal,color:q.status==1?'green':"red"}}>{q.status==1?<CheckIcon style={{fontSize:fNormal}}/>:"X"}</div>
                      </Grid>
                  </Grid>)
                }):false}
                <Divider />
                <div style={{textAlign: 'right', fontSize: fSmall, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.total')}: {result.countCorrect}/{result.qlength}<br />({result.percent}%)</div>
              <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                <img
                src="assets/web/logo_green.png"
                style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                </div>

          </div>
        </Modal>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: wWidth , background: 'white',textAlign:'center' } }} open={showChart} onClose={() => this.setState({ showChart: false,showChartDetail:false })} center>
          <div>
            <div style={{ display: 'flex' }}>
              {this.state.showChartDetail&&!this.state.showAdvanceResult?<ButtonBase
                focusRipple
                onClick={() => this.setState({showChartDetail:false})}
                style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                <BackIcon style={{ color: 'white', fontSize: fTitle }} />
              </ButtonBase>:false}
                <div style={{textAlign: 'center', flexGrow: 1, fontSize: fTitle, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{this.state.showChartDetail&&!this.state.showAdvanceResult?t('common.results_for_week')+(this.state.chartWeekIndex+1):t('common.results')}</div>
                </div>
                <div style={{textAlign: 'center', fontSize: fTitle, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{this.state.showAdvanceResult?t('common.aresults_for',{name:name_student}):t('common.tresults_for',{name:name_student})}</div>
                {this.state.showAdvanceResult?<div>
                  <Grid container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}}>
                    <Grid item>
                      <FormControl style={{ width: width * 0.2 }}>
                        <Select
                          value={this.state.curLegend}
                          onChange={e=>this.setState({curLegend:e.target.value})}

                          style={{ backgroundColor: '#fdce07', border: 'none', color: "#053f22", padding: 5, textAlign: 'left', fontSize: fNormal }}

                        >
                          {this.state.keyOptions.map((t, index) => {
                            return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t}>
                              {t}
                            </MenuItem>)
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid><div style={{height:"500px",width:wWidth,marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}><VictoryChart
height={500} width={wWidth}
domainPadding={22}
>

{chartData2.map((cData,index)=>{
return [<VictoryScatter
key={'sc'+index}
style={{ data: { fill: ({ datum }) => datum.color } }}
size={8}
x="name"
data={chartData2[index]}
events={[{
    target: "data",
    eventHandlers: {
        onClick: () => {

            return [
                {
                    target: "data",
                    mutation: (props) => {
                      let data = props.data[props.index];
                      _this.clickChart2(data.key,data.date);
                    }
                },
            ];
        }
    }
}]}
/>,<VictoryLine
key={'VL'+index}
interpolation="cardinal"
      data={chartData2[index]}
      x="name"

      labels={({ datum }) => datum.y+'%'}
      domain={ { y: [0, 100] } }
      style={{ labels: { fill: ({ datum }) => datum.color },data: { stroke: cData[0].color, strokeWidth: STATIC.calSize(1, STATIC.DWIDTH, width) },
   }}
      labelComponent={<VictoryLabel dy={STATIC.calSize(10, STATIC.DWIDTH, width)*-1}/>}
      events={[
    {
      target: "data",
      eventHandlers: {
        onPress: () => {
          return [{
            target: "labels",
            mutation: (props) => {
              console.log(props);
              _this.clickChart(props.index);
              return null;
            }
          }];
        }
      }
    }
  ]}
       />]
})}
<VictoryLegend
title=""
centerTitle
orientation="horizontal"
itemsPerRow={6}
gutter={STATIC.calSize(10, STATIC.DWIDTH, width)}
style={{ border: { stroke: "black" }, title: {fontSize: 1 },labels: { fontSize:fSmall  } }}
data={legends.filter(l=>this.state.curLegend==''||this.state.curLegend=='All'||this.state.curLegend==l.name)}
/>
     <VictoryAxis
     label={this.state.showAdvanceResult?'Date':!this.state.showChartDetail?t('common.week'):t('common.day')}

               style={{
         axis: {stroke: "#756f6a"},
         axisLabel: {fontSize: 20, padding: STATIC.calSize(20, STATIC.DWIDTH, width)},

         ticks: {stroke: "grey", size: 5},
         tickLabels: {fontSize: fSmall, padding: STATIC.calSize(5, STATIC.DWIDTH, width)}
       }}

             />
     <VictoryAxis
     dependentAxis
               tickValues={[0,20,40,60,80,100]}


             /></VictoryChart></div></div>
           :<div style={{height:"500px",width:wWidth,marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}><VictoryChart
height={500} width={wWidth}
domainPadding={22}
>

<VictoryBar
    data={this.state.showAdvanceResult?this.state.chartData2:!this.state.showChartDetail?this.state.chartData:this.state.chartDetailData}
    x="name"
    y="percent"
    labels={({ datum }) => datum.percent!=0?datum.percent+'%':""}
    domain={ { y: [0, 100] } }
    style={{ labels: { fill: !this.state.showChartDetail?"white":"#053f22" },
  data: { fill: !this.state.showChartDetail?"#053f22":'#fdce07',width:STATIC.calSize(40, STATIC.DWIDTH, width) }
 }}
    labelComponent={<VictoryLabel dy={STATIC.calSize(20, STATIC.DWIDTH, width)}/>}
    events={[
  {
    target: "data",
    eventHandlers: {
      onClick: () => {
        return [{
          target: "labels",
          mutation: (props) => {
            _this.clickChart(props.index);
            return null;
          }
        }];
      }
    }
  }
]}
     />
     <VictoryAxis
     label={this.state.showAdvanceResult?'Date':!this.state.showChartDetail?t('common.week'):t('common.day')}

               style={{
         axis: {stroke: "#756f6a"},
         axisLabel: {fontSize: 20, padding: STATIC.calSize(20, STATIC.DWIDTH, width)},

         ticks: {stroke: "grey", size: 5},
         tickLabels: {fontSize: fSmall, padding: STATIC.calSize(5, STATIC.DWIDTH, width)}
       }}

             />
     <VictoryAxis
     dependentAxis
               tickValues={[0,20,40,60,80,100]}


             /></VictoryChart></div>}
              <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                <img
                src="assets/web/logo_green.png"
                style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                </div>
                <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'),marginLeft:'auto', minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showAdvanceResult: !this.state.showAdvanceResult})}>
                  {this.state.showAdvanceResult?t('practice.practice'):t('common.advance')}
                      </Button>

          </div>
        </Modal>
        <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>this.setState({showSetRow:false})} showCloseIcon={false} focusTrapped={false} open={this.state.showSetRow} center>
          <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
            <div style={{ display: 'flex',flexDirection:'column',justifyContent:'center',alignItems:'center' }}>

                <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.set_rows')}</div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('rows',40)}
                      value={this.state.rows}
                      type="number"
                      min={3}
                      max={40}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>


                  <Button onClick={()=>this.saveMSetting()} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                    {t('common.save')}
                  </Button>

                </div>
                </div>
              </div>
            </Modal>
            <Modal2
open={this.state.loading}
onClose={() => this.setState({ loading: false })}
aria-labelledby="simple-modal-title"
aria-describedby="simple-modal-description"
>
<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
<div style={{textAlign:'center'}}>
<CircularProgress style={{color:'white'}}/>
</div>
</div>
</Modal2>


      </div>
    );
  }
}


Practice.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Practice));
